<template>
  <div id="app">
    <transition name="overflow-fade">
      <div
        v-if="$root.ready && overflow"
        class="ready-overflow"
        @click="openWebsite()"
      >
        <div class="text-center w-100">
          <div class="title">The Wedding</div>
          <span>of</span>
          <div class="mb-5 name">
            {{ wedding.man.surname }}
            <div class="py-3" style="margin-top: -1rem; margin-bottom: -1rem;">
              &
            </div>
            {{ wedding.woman.surname }}
          </div>

          <button
            class="text-uppercase btn btn-outline-primary"
            @click="openWebsite()"
          >
            Buka Undangan
          </button>
        </div>
      </div>
    </transition>

    <AGWAudio
      :file="music.file"
      :loop="music.loop"
      :autoplay="music.autoplay"
      ref="audio"
    />
    <AGWHero
      overlay
      :images="backgrounds"
      ref="hero"
      parallax
      target="#intro"
    />

    <div
      class="bg-white agw-content"
      :style="{ 'margin-top': `${$root.hero.height}px` }"
    >
      <AGWIntro id="intro" />

      <AGWPawiwahan id="pawiwahan" class="bg-blue-light py-5" />
      <AGWMepandes id="mepandes" class="pad-y-60" :mepandes="mepandes" />

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="py-5" />
    </div>

    <div class="agw-content" style="background: transparent">
      <Himbauan />
      <attendance id="attendance" class="pad-y-60"></attendance>

      <div class="container mb-5">
        <button class="wedding-gift btn-primary" @click="giftOpen = true">
          <svg
            enable-background="new 0 0 512 512"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 mr-4"
          >
            <g>
              <g>
                <path
                  d="m301.218 250.733c6.642 6.979 13.876 13.216 20.872 18.581l34.95 9 34.95-9c6.996-5.365 14.23-11.602 20.872-18.581l-55.822-9z"
                  fill="#ffacca"
                ></path>
                <path
                  d="m412.862 250.733c16.344-17.172 29.086-38.862 25.746-63.287-7.252-53.033-71.449-47.794-81.569-15.489-10.12-32.305-74.317-37.544-81.568 15.489-3.34 24.425 9.402 46.115 25.746 63.287z"
                  fill="#ffb8c7"
                ></path>
                <path
                  d="m192.631 502.419h303.883c8.553 0 15.487-5.906 15.487-24.487v-203.618c0-2.762-2.238-5-5-5h-139.917l-22.512 9-22.512-9h-139.916c-2.761 0-5 2.238-5 5v203.618c0 18.581 6.933 24.487 15.487 24.487z"
                  fill="#fce39f"
                ></path>
                <path
                  d="m496.513 493.419h-303.882c-8.553 0-15.487-6.934-15.487-15.487v18.581c0 8.553 6.934 15.487 15.487 15.487h129.43l22.512-9.581 22.511 9.581h129.43c8.553 0 15.487-6.934 15.487-15.487v-18.581c-.001 8.553-6.935 15.487-15.488 15.487z"
                  fill="#f5d88b"
                ></path>
                <path
                  d="m367.084 269.314h-45.024v224.105l22.512 9 22.512-9z"
                  fill="#f3746b"
                ></path>
                <path
                  d="m322.06 493.419h45.023v18.581h-45.023z"
                  fill="#e7635f"
                ></path>
                <g>
                  <path
                    d="m86.573 319.307 22.862-34.181v-48.775c-18.45-5.359-46.994-10.504-61.216 3.121-19.773 18.943 17.221 74.007 17.221 74.007l8.993 10.637z"
                    fill="#f3746b"
                  ></path>
                  <path
                    d="m104.078 324.134 22.578-32.406v-49.428s-7.09-3.007-17.221-5.95l-22.862 82.955 6.983 8.461z"
                    fill="#e7635f"
                  ></path>
                  <path
                    d="m74.434 363.356-7.924-8.903-13.182 3.082s-59.993 28.297-52.716 54.7c5.234 18.989 32.375 29.202 50.964 34.058l22.857-40.946v-41.991z"
                    fill="#f3746b"
                  ></path>
                  <path
                    d="m69.418 450.013 22.545-37.513.002-44.31-7.024-9.222-10.508 4.387-22.857 82.937c10.21 2.668 17.842 3.721 17.842 3.721z"
                    fill="#e7635f"
                  ></path>
                  <path
                    d="m86.558 319.304.015 24.445-12.141 19.608-21.118-5.826 12.127-44.052z"
                    fill="#c75058"
                  ></path>
                  <path
                    d="m91.965 368.191 13.998-19.625-1.885-24.432-17.505-4.827-12.139 44.049z"
                    fill="#b74a56"
                  ></path>
                  <path
                    d="m177.898 203.531-27.591-7.609c-5.58-1.539-11.35 1.739-12.888 7.321l-78.764 285.828c-1.538 5.582 1.738 11.354 7.318 12.893l27.583 7.607 14.572-18.635 70.32-255.16z"
                    fill="#fce39f"
                  ></path>
                  <path
                    d="m185.322 205.579-7.424-2.047-84.342 306.039 7.432 2.05c5.58 1.539 11.35-1.739 12.888-7.32l78.764-285.828c1.538-5.583-1.738-11.355-7.318-12.894z"
                    fill="#f5d88b"
                  ></path>
                  <path
                    d="m129.653 378.592 14.839-19.624-2.691-24.458-37.69-10.394-12.148 44.082z"
                    fill="#f3746b"
                  ></path>
                  <path
                    d="m121.63 349.876h45.725v18.185h-45.725z"
                    fill="#e7635f"
                    transform="matrix(.266 -.964 .964 .266 -239.972 402.828)"
                  ></path>
                </g>
                <path
                  d="m284.724 15.398c0 27.808 30.661 43.798 38.528 48.086 1.53.834 3.376.834 4.905 0 7.867-4.289 38.528-22.027 38.528-48.086-6.995-21.762-36.109-18.361-40.981-2.808-4.871-15.553-33.985-18.954-40.98 2.808z"
                  fill="#ffb8c7"
                ></path>
                <path
                  d="m450.984 106.904c1.55.847 3.415.847 4.964 0 7.688-4.203 37.102-18.114 37.102-46.472-6.931-20.763-34.888-17.437-39.584-2.444-4.697-14.993-32.653-18.318-39.584 2.444 0 28.358 29.414 42.269 37.102 46.472z"
                  fill="#ffb8c7"
                ></path>
                <path
                  d="m213.355 151.194c1.549.847 3.415.847 4.964 0 7.688-4.203 37.102-19.32 37.102-46.472-6.932-20.762-34.888-17.437-39.584-2.444-4.697-14.993-32.653-18.318-39.584 2.444-.001 26.428 29.413 42.269 37.102 46.472z"
                  fill="#ffb8c7"
                ></path>
                <g fill="#ffacca">
                  <path
                    d="m255.421 104.721c-6.142 19.208-29.414 33.269-37.102 37.472-1.55.847-3.415.847-4.964 0-7.688-4.203-30.96-18.264-37.102-37.472-.543 1.625-.972 3.38-1.235 5.307-3.551 25.966 29.21 45.772 38.44 50.802 1.485.809 3.273.809 4.758 0 9.23-5.031 41.991-24.837 38.44-50.802-.263-1.926-.693-3.681-1.235-5.307z"
                  ></path>
                  <path
                    d="m366.687 15.398c-6.212 20.097-30.661 34.797-38.528 39.086-1.53.834-3.376.834-4.905 0-7.867-4.289-32.316-18.99-38.528-39.086-.514 1.599-.92 3.321-1.176 5.198-3.677 26.892 30.359 47.388 39.781 52.511 1.486.808 3.268.808 4.753 0 9.422-5.124 43.458-25.619 39.781-52.511-.259-1.877-.665-3.599-1.178-5.198z"
                  ></path>
                  <path
                    d="m493.051 60.432c-6.142 19.208-29.414 33.269-37.102 37.472-1.549.847-3.415.847-4.964 0-7.688-4.203-30.96-18.264-37.102-37.472-.542 1.625-.972 3.38-1.235 5.307-3.551 25.966 29.21 45.771 38.44 50.802 1.485.809 3.273.809 4.758 0 9.23-5.031 41.991-24.837 38.44-50.802-.264-1.926-.693-3.681-1.235-5.307z"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
          Send Wedding Gift
        </button>

        <transition name="fade">
          <div v-if="giftOpen" class="wedding-gift-modal">
            <button class="close" @click="giftOpen = false">&times;</button>

            <div class="container">
              <svg
                width="100"
                enable-background="new 0 0 512 512"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                class="mb-4"
              >
                <g>
                  <g>
                    <path
                      d="m301.218 250.733c6.642 6.979 13.876 13.216 20.872 18.581l34.95 9 34.95-9c6.996-5.365 14.23-11.602 20.872-18.581l-55.822-9z"
                      fill="#ffacca"
                    ></path>
                    <path
                      d="m412.862 250.733c16.344-17.172 29.086-38.862 25.746-63.287-7.252-53.033-71.449-47.794-81.569-15.489-10.12-32.305-74.317-37.544-81.568 15.489-3.34 24.425 9.402 46.115 25.746 63.287z"
                      fill="#ffb8c7"
                    ></path>
                    <path
                      d="m192.631 502.419h303.883c8.553 0 15.487-5.906 15.487-24.487v-203.618c0-2.762-2.238-5-5-5h-139.917l-22.512 9-22.512-9h-139.916c-2.761 0-5 2.238-5 5v203.618c0 18.581 6.933 24.487 15.487 24.487z"
                      fill="#fce39f"
                    ></path>
                    <path
                      d="m496.513 493.419h-303.882c-8.553 0-15.487-6.934-15.487-15.487v18.581c0 8.553 6.934 15.487 15.487 15.487h129.43l22.512-9.581 22.511 9.581h129.43c8.553 0 15.487-6.934 15.487-15.487v-18.581c-.001 8.553-6.935 15.487-15.488 15.487z"
                      fill="#f5d88b"
                    ></path>
                    <path
                      d="m367.084 269.314h-45.024v224.105l22.512 9 22.512-9z"
                      fill="#f3746b"
                    ></path>
                    <path
                      d="m322.06 493.419h45.023v18.581h-45.023z"
                      fill="#e7635f"
                    ></path>
                    <g>
                      <path
                        d="m86.573 319.307 22.862-34.181v-48.775c-18.45-5.359-46.994-10.504-61.216 3.121-19.773 18.943 17.221 74.007 17.221 74.007l8.993 10.637z"
                        fill="#f3746b"
                      ></path>
                      <path
                        d="m104.078 324.134 22.578-32.406v-49.428s-7.09-3.007-17.221-5.95l-22.862 82.955 6.983 8.461z"
                        fill="#e7635f"
                      ></path>
                      <path
                        d="m74.434 363.356-7.924-8.903-13.182 3.082s-59.993 28.297-52.716 54.7c5.234 18.989 32.375 29.202 50.964 34.058l22.857-40.946v-41.991z"
                        fill="#f3746b"
                      ></path>
                      <path
                        d="m69.418 450.013 22.545-37.513.002-44.31-7.024-9.222-10.508 4.387-22.857 82.937c10.21 2.668 17.842 3.721 17.842 3.721z"
                        fill="#e7635f"
                      ></path>
                      <path
                        d="m86.558 319.304.015 24.445-12.141 19.608-21.118-5.826 12.127-44.052z"
                        fill="#c75058"
                      ></path>
                      <path
                        d="m91.965 368.191 13.998-19.625-1.885-24.432-17.505-4.827-12.139 44.049z"
                        fill="#b74a56"
                      ></path>
                      <path
                        d="m177.898 203.531-27.591-7.609c-5.58-1.539-11.35 1.739-12.888 7.321l-78.764 285.828c-1.538 5.582 1.738 11.354 7.318 12.893l27.583 7.607 14.572-18.635 70.32-255.16z"
                        fill="#fce39f"
                      ></path>
                      <path
                        d="m185.322 205.579-7.424-2.047-84.342 306.039 7.432 2.05c5.58 1.539 11.35-1.739 12.888-7.32l78.764-285.828c1.538-5.583-1.738-11.355-7.318-12.894z"
                        fill="#f5d88b"
                      ></path>
                      <path
                        d="m129.653 378.592 14.839-19.624-2.691-24.458-37.69-10.394-12.148 44.082z"
                        fill="#f3746b"
                      ></path>
                      <path
                        d="m121.63 349.876h45.725v18.185h-45.725z"
                        fill="#e7635f"
                        transform="matrix(.266 -.964 .964 .266 -239.972 402.828)"
                      ></path>
                    </g>
                    <path
                      d="m284.724 15.398c0 27.808 30.661 43.798 38.528 48.086 1.53.834 3.376.834 4.905 0 7.867-4.289 38.528-22.027 38.528-48.086-6.995-21.762-36.109-18.361-40.981-2.808-4.871-15.553-33.985-18.954-40.98 2.808z"
                      fill="#ffb8c7"
                    ></path>
                    <path
                      d="m450.984 106.904c1.55.847 3.415.847 4.964 0 7.688-4.203 37.102-18.114 37.102-46.472-6.931-20.763-34.888-17.437-39.584-2.444-4.697-14.993-32.653-18.318-39.584 2.444 0 28.358 29.414 42.269 37.102 46.472z"
                      fill="#ffb8c7"
                    ></path>
                    <path
                      d="m213.355 151.194c1.549.847 3.415.847 4.964 0 7.688-4.203 37.102-19.32 37.102-46.472-6.932-20.762-34.888-17.437-39.584-2.444-4.697-14.993-32.653-18.318-39.584 2.444-.001 26.428 29.413 42.269 37.102 46.472z"
                      fill="#ffb8c7"
                    ></path>
                    <g fill="#ffacca">
                      <path
                        d="m255.421 104.721c-6.142 19.208-29.414 33.269-37.102 37.472-1.55.847-3.415.847-4.964 0-7.688-4.203-30.96-18.264-37.102-37.472-.543 1.625-.972 3.38-1.235 5.307-3.551 25.966 29.21 45.772 38.44 50.802 1.485.809 3.273.809 4.758 0 9.23-5.031 41.991-24.837 38.44-50.802-.263-1.926-.693-3.681-1.235-5.307z"
                      ></path>
                      <path
                        d="m366.687 15.398c-6.212 20.097-30.661 34.797-38.528 39.086-1.53.834-3.376.834-4.905 0-7.867-4.289-32.316-18.99-38.528-39.086-.514 1.599-.92 3.321-1.176 5.198-3.677 26.892 30.359 47.388 39.781 52.511 1.486.808 3.268.808 4.753 0 9.422-5.124 43.458-25.619 39.781-52.511-.259-1.877-.665-3.599-1.178-5.198z"
                      ></path>
                      <path
                        d="m493.051 60.432c-6.142 19.208-29.414 33.269-37.102 37.472-1.549.847-3.415.847-4.964 0-7.688-4.203-30.96-18.264-37.102-37.472-.542 1.625-.972 3.38-1.235 5.307-3.551 25.966 29.21 45.771 38.44 50.802 1.485.809 3.273.809 4.758 0 9.23-5.031 41.991-24.837 38.44-50.802-.264-1.926-.693-3.681-1.235-5.307z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
              <h2>Send Wedding Gift</h2>
              <div>Doa, berkah, cinta & dukungan Anda terhadap setiap jalan yang kami pijak adalah hadiah terbesar yang pernah kami minta. Namun, jika Anda ingin mengirim sesuatu, Anda dapat mengirimkannya melalui rekening dibawah ini.</div>

              <div class="mt-5">
                <div class="mb-5">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/BANK_BRI_logo.svg/2560px-BANK_BRI_logo.svg.png" />
                  <div class="font-weight-bold mt-2">001701090947502</div>
                  <div>Gede Agus Purnama Yogi</div>
                  <button class="copy" @click.prevent="e => copyToClipboard('001701090947502', e)">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512" height="512px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve"><path d="M468.493,101.637L371.955,5.098H159.57v77.231H43.724v424.769h308.923v-77.231h115.846V101.637z   M371.955,32.401l69.236,69.235h-69.236V32.401z M63.031,487.79V101.637h173.769v96.538h96.538V487.79H63.031z M256.108,109.632  l69.236,69.235h-69.236V109.632z M352.647,410.56V178.867l-96.538-96.538h-77.231V24.406h173.769v96.538h96.538V410.56H352.647z" fill="#37404D"/></svg>
                    Copy No. Rekening
                  </button>
                </div>

                <div class="">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/BANK_BRI_logo.svg/2560px-BANK_BRI_logo.svg.png" />
                  <div class="font-weight-bold mt-2">001701095091500</div>
                  <div>Ni Putu Juni Toniari</div>
                  <button class="copy" @click.prevent="e => copyToClipboard('001701095091500', e)">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512" height="512px" id="Layer_1" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve"><path d="M468.493,101.637L371.955,5.098H159.57v77.231H43.724v424.769h308.923v-77.231h115.846V101.637z   M371.955,32.401l69.236,69.235h-69.236V32.401z M63.031,487.79V101.637h173.769v96.538h96.538V487.79H63.031z M256.108,109.632  l69.236,69.235h-69.236V109.632z M352.647,410.56V178.867l-96.538-96.538h-77.231V24.406h173.769v96.538h96.538V410.56H352.647z" fill="#37404D"/></svg>
                    Copy No. Rekening
                  </button>
                </div>
              </div>
            </div>

          </div>
        </transition>
      </div>
    </div>
    <div class="container text-center pad-y-60 mt-5" style="padding-top: 120px">
      <svg
        width="300"
        viewBox="0 0 78 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mx-auto"
      >
        <path
          d="M4.03562 15.94C6.30362 15.94 7.63562 14.068 8.53562 11.668C9.19562 11.944 9.56762 12.004 10.0716 12.004C10.6836 12.004 11.6676 11.776 11.6676 11.332C11.6676 11.248 11.6196 11.188 11.5236 11.188C11.4996 11.188 11.4636 11.188 11.4276 11.2C10.9956 11.38 10.8036 11.536 10.1436 11.548C9.66362 11.548 9.33962 11.5 8.69162 11.236C9.49562 8.896 9.87962 6.34 10.5036 4.552C11.4156 3.952 11.6796 3.748 11.9076 3.532C12.2796 3.16 12.4236 2.872 12.4236 2.668C12.4236 2.476 12.2796 2.368 12.0516 2.368C11.6916 2.368 11.1396 2.656 10.7196 3.268C10.4556 3.664 10.2516 4.132 10.0956 4.552C8.30762 5.8 6.39962 7.168 4.70762 8.56C4.35962 8.284 3.89162 7.96 3.56762 7.96C3.24362 7.96 2.94362 8.212 2.57162 8.86C2.19962 9.496 1.76762 10.504 1.53962 11.536C0.87962 12.292 0.13562 13.36 0.13562 14.164C0.13562 14.332 0.14762 14.404 0.27962 14.404C0.42362 14.404 0.61562 14.284 0.61562 14.116V13.996C0.61562 13.396 0.99962 12.712 1.41962 12.124C1.37162 12.46 1.33562 12.796 1.33562 13.108C1.33562 14.668 2.01962 15.808 3.69962 15.928L4.03562 15.94ZM10.6356 4.18C10.7436 3.904 10.8636 3.628 11.0316 3.364C11.3076 2.932 11.7036 2.692 11.9196 2.692C12.0036 2.692 12.0516 2.74 12.0516 2.812C12.0516 2.92 11.9556 3.1 11.7036 3.364C11.4156 3.664 11.1756 3.808 10.6356 4.18ZM8.30762 11.068C6.91562 10.408 5.75162 9.376 4.87562 8.68C6.47162 7.348 8.25962 6.064 9.97562 4.9C9.38762 6.676 8.96762 8.992 8.30762 11.068ZM1.85162 11.176C2.18762 9.928 2.96762 8.296 3.45962 8.296C3.69962 8.296 4.05962 8.572 4.39562 8.824C3.51962 9.556 2.61962 10.348 1.85162 11.176ZM4.09562 15.712L3.80762 15.7C2.22362 15.58 1.58762 14.5 1.58762 13.036C1.58762 12.628 1.63562 12.184 1.73162 11.728C2.51162 10.756 3.57962 9.772 4.55162 8.956C5.49962 9.724 6.69962 10.816 8.17562 11.512C7.39562 13.84 6.26762 15.712 4.09562 15.712Z"
          fill="currentColor"
        ></path>
        <path
          d="M12.6347 12.268C13.0787 12.268 13.6787 12.004 14.1947 11.452C14.2187 11.428 14.2307 11.392 14.2307 11.368C14.2307 11.332 14.2067 11.308 14.1587 11.308C14.1347 11.308 14.0987 11.32 14.0747 11.356C13.5947 11.872 13.0787 12.148 12.7427 12.148C12.5027 12.148 12.3467 12.004 12.3467 11.728C12.3467 11.5 12.4427 11.176 12.6707 10.756L12.6827 10.708C12.6827 10.624 12.5867 10.588 12.4907 10.588C12.3107 10.588 12.2627 10.648 12.2147 10.756C12.1547 10.708 12.0707 10.684 11.9627 10.684C11.4947 10.732 11.0147 11.488 11.0147 11.932C11.0147 12.1 11.0867 12.22 11.2667 12.22C11.5547 12.22 11.8067 11.98 12.0227 11.704V11.716C12.0227 12.088 12.2747 12.268 12.6347 12.268ZM11.4467 11.848C11.4347 11.848 11.4227 11.836 11.4227 11.812C11.4227 11.644 11.7587 11.032 11.9027 11.032C11.9627 11.032 11.9747 11.092 11.9747 11.164C11.9747 11.224 11.9627 11.284 11.9507 11.308C11.8187 11.56 11.6027 11.848 11.4467 11.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M13.9704 12.616C14.0424 12.616 14.1264 12.568 14.1504 12.484C14.2824 12.076 15.0744 10.816 15.5664 10.444C15.4584 10.768 15.1224 11.584 15.1224 11.944C15.1224 12.124 15.1944 12.196 15.2904 12.196C15.6264 12.196 16.2624 11.236 16.6104 11.236C16.7064 11.236 16.7904 11.308 16.8384 11.488C16.9584 11.932 17.2224 12.112 17.5464 12.112C17.9424 12.112 18.4224 11.848 18.8544 11.416C18.8904 11.38 18.9024 11.344 18.9024 11.32C18.9024 11.272 18.8664 11.236 18.8184 11.236C18.7944 11.236 18.7464 11.26 18.7104 11.296C18.3504 11.656 17.9304 11.98 17.6064 11.98C17.3664 11.98 17.1864 11.812 17.1024 11.356C17.0544 11.056 16.9104 10.924 16.7064 10.924C16.4304 10.924 16.0584 11.152 15.6624 11.524C15.7704 11.152 15.9144 10.792 15.9504 10.384C15.9504 10.216 15.8784 10.144 15.7704 10.144C15.6504 10.144 15.4824 10.24 15.3144 10.408C14.9904 10.732 14.4744 11.488 14.2344 11.86C14.4024 11.428 14.5944 11.128 14.6064 11.068L14.6184 10.996C14.6184 10.888 14.5464 10.84 14.4504 10.84C14.3304 10.84 14.1864 10.924 14.1384 11.08V11.092C14.0304 11.428 13.8024 12.1 13.8024 12.4C13.8024 12.556 13.8864 12.616 13.9704 12.616Z"
          fill="currentColor"
        ></path>
        <path
          d="M17.0762 16.852C17.2082 16.852 17.3521 16.708 17.3521 16.6C17.3521 16.552 17.3282 16.516 17.2802 16.492C17.2802 15.892 17.9642 14.092 18.2282 13.336C18.2642 13.324 18.2762 13.3 18.2882 13.276C18.5042 12.736 19.4402 10.852 19.8962 10.576C19.9082 10.6 19.9081 10.672 19.9081 10.78V10.852C19.9081 11.296 19.9322 12.064 20.6522 12.064C21.2522 12.064 21.9362 11.452 21.9962 11.368C22.0202 11.332 22.0322 11.296 22.0322 11.26C22.0322 11.2 21.9842 11.152 21.9122 11.152C21.8522 11.152 21.7801 11.188 21.7201 11.272C21.4801 11.62 21.1322 11.932 20.7362 11.932C20.4242 11.932 20.3642 11.644 20.3642 11.32L20.3762 10.876C20.3762 10.576 20.3401 10.324 20.0641 10.324H20.0042C19.8482 10.348 19.4402 10.516 18.7082 12.076C19.2242 10.756 19.4162 10.36 19.4282 10.3L19.4402 10.228C19.4402 10.132 19.3682 10.084 19.2842 10.084C19.1642 10.084 19.0081 10.168 18.9601 10.324C18.6361 11.392 17.2561 15.64 17.0161 16.336C16.9801 16.456 16.9321 16.588 16.9321 16.696C16.9321 16.816 16.9682 16.84 17.0762 16.852Z"
          fill="currentColor"
        ></path>
        <path
          d="M23.1347 12.268C23.5787 12.268 24.1787 12.004 24.6947 11.452C24.7187 11.428 24.7307 11.392 24.7307 11.368C24.7307 11.332 24.7067 11.308 24.6587 11.308C24.6347 11.308 24.5987 11.32 24.5747 11.356C24.0947 11.872 23.5787 12.148 23.2427 12.148C23.0027 12.148 22.8467 12.004 22.8467 11.728C22.8467 11.5 22.9427 11.176 23.1707 10.756L23.1827 10.708C23.1827 10.624 23.0867 10.588 22.9907 10.588C22.8107 10.588 22.7627 10.648 22.7147 10.756C22.6547 10.708 22.5707 10.684 22.4627 10.684C21.9947 10.732 21.5147 11.488 21.5147 11.932C21.5147 12.1 21.5867 12.22 21.7667 12.22C22.0547 12.22 22.3067 11.98 22.5227 11.704V11.716C22.5227 12.088 22.7747 12.268 23.1347 12.268ZM21.9467 11.848C21.9347 11.848 21.9227 11.836 21.9227 11.812C21.9227 11.644 22.2587 11.032 22.4027 11.032C22.4627 11.032 22.4747 11.092 22.4747 11.164C22.4747 11.224 22.4627 11.284 22.4507 11.308C22.3187 11.56 22.1027 11.848 21.9467 11.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M25.2984 12.124C25.7184 12.124 26.2944 11.932 27.0264 11.416C27.0624 11.392 27.0744 11.368 27.0744 11.344C27.0744 11.308 27.0504 11.272 27.0024 11.272C26.9784 11.272 26.9544 11.284 26.9184 11.308C26.4624 11.704 25.8624 12.016 25.4544 12.016C25.1784 12.016 24.9984 11.872 24.9984 11.536C24.9984 11.368 25.0344 11.14 25.1424 10.864L25.1544 10.816C25.1544 10.732 25.0704 10.684 24.9864 10.684C24.8784 10.684 24.7464 10.744 24.6744 10.876C24.5784 11.056 24.5184 11.248 24.5184 11.416C24.5184 11.812 24.7824 12.124 25.2984 12.124ZM25.1064 10.324C25.2504 10.324 25.3464 10.24 25.3704 10.12C25.3704 10.06 25.3104 10.012 25.2264 10.012C25.0824 10.012 24.9984 10.096 24.9744 10.216C24.9744 10.276 25.0344 10.324 25.1064 10.324Z"
          fill="currentColor"
        ></path>
        <path
          d="M31.3235 13.576C31.7795 13.576 32.3315 13.192 32.7035 12.568H32.7395C33.7475 12.568 34.8395 11.74 34.9715 11.26C34.9715 11.2 34.9235 11.164 34.8515 11.164C34.7795 11.164 34.6835 11.212 34.6355 11.308C34.3835 11.848 33.6515 12.328 33.0155 12.328L32.8355 12.316C33.0275 11.932 33.1235 11.548 33.1235 11.248C33.1235 10.936 33.0155 10.732 32.7635 10.732C32.7155 10.732 32.6555 10.744 32.5835 10.768C32.1995 10.888 31.9115 11.38 31.9115 11.824C31.9115 12.16 32.0795 12.46 32.5115 12.544C32.1995 13.012 31.8035 13.288 31.4795 13.288C31.1315 13.288 30.8675 12.988 30.8675 12.268C30.8675 12.028 30.8915 11.764 30.9515 11.44C32.5355 10.504 34.0595 8.668 34.9835 7.144C35.7275 5.92 36.0275 5.008 36.0275 4.42C36.0275 3.928 35.8115 3.676 35.4515 3.676C34.8155 3.676 33.7235 4.504 32.6315 6.256C31.6955 7.768 30.8555 9.7 30.5675 11.2C30.4715 11.272 30.4235 11.368 30.4235 11.452C30.4235 11.512 30.4475 11.572 30.5075 11.596C30.4835 11.824 30.4595 12.016 30.4595 12.208C30.4595 13.156 30.8435 13.576 31.3235 13.576ZM31.0595 10.984C31.3835 9.628 32.1155 7.84 33.0035 6.352C33.9635 4.744 34.8515 4.012 35.3315 4.012C35.5835 4.012 35.7275 4.204 35.7275 4.564C35.7275 5.08 35.4395 5.932 34.7675 7.084C33.9515 8.476 32.5355 10.228 31.0595 10.984ZM32.6555 12.28C32.3675 12.184 32.2595 11.932 32.2595 11.68C32.2595 11.296 32.4395 11.008 32.6795 10.972C32.8235 10.972 32.9075 11.14 32.9075 11.38C32.9075 11.62 32.8355 11.932 32.6555 12.28Z"
          fill="currentColor"
        ></path>
        <path
          d="M35.3774 12.544C36.1214 12.544 37.1534 12.064 37.6454 11.332C37.6574 11.308 37.6694 11.284 37.6694 11.26C37.6694 11.2 37.6214 11.176 37.5614 11.176C37.5014 11.176 37.4294 11.212 37.3934 11.284C37.0094 11.956 36.1694 12.328 35.5454 12.328C35.1254 12.328 34.8134 12.16 34.8134 11.8L34.8254 11.644C35.0894 11.584 35.3654 11.488 35.6294 11.368C36.1454 11.104 36.3734 10.804 36.3734 10.588C36.3734 10.444 36.2534 10.348 36.0494 10.348C35.6774 10.348 35.0294 10.696 34.7174 11.248C34.5134 11.272 34.4054 11.428 34.4054 11.56C34.4054 11.632 34.4534 11.692 34.5494 11.704L34.5374 11.872C34.5374 12.34 34.8974 12.544 35.3774 12.544ZM35.0654 11.176C35.3174 10.864 35.7854 10.684 35.9294 10.684C35.9654 10.684 35.9774 10.684 35.9774 10.708C35.9774 10.816 35.5214 11.08 35.0654 11.176Z"
          fill="currentColor"
        ></path>
        <path
          d="M38.9947 15.556C39.1147 15.556 39.2227 15.46 39.2227 15.364C39.2227 15.316 39.1987 15.28 39.1387 15.244L39.1267 15.052C39.1267 14.236 39.5227 13.312 39.7627 12.472C40.4707 10.384 41.2987 8.296 42.1147 6.208C43.0027 6.268 43.9987 6.352 45.0427 6.352C46.9627 6.352 49.0267 6.064 50.7907 4.804C51.6067 4.216 52.1227 3.304 52.1227 2.548C52.1227 1.06 49.8787 0.363998 47.7907 0.363998C45.5707 0.363998 43.0267 1.048 41.4787 2.368C41.2147 2.584 40.7347 3.088 40.7347 3.388C40.7347 3.484 40.7947 3.604 40.9627 3.604C41.1187 3.604 41.2387 3.448 41.2387 3.328C41.2387 3.268 41.2147 3.232 41.1547 3.208C42.5467 1.132 45.4987 0.567999 47.7307 0.567999C50.0827 0.567999 51.9667 1.228 51.9667 2.632C51.9667 3.664 50.8867 4.828 49.6507 5.356C48.1147 6.016 46.6267 6.208 45.1867 6.208C44.1547 6.208 43.1587 6.112 42.1987 6.016C42.4987 5.224 42.9187 4.24 43.1587 3.46L43.1827 3.352C43.1827 3.244 43.1107 3.172 43.0147 3.172C42.8827 3.172 42.6907 3.328 42.6907 3.484V3.52C42.4627 4.336 42.1147 5.152 41.8147 5.968C40.1227 5.836 37.7347 5.236 35.4187 5.236C33.8587 5.236 32.3467 5.512 31.0987 6.4C31.0027 6.472 30.9667 6.556 30.9667 6.628C30.9667 6.724 31.0387 6.796 31.1347 6.796C31.1947 6.796 31.2547 6.772 31.3147 6.724C32.5627 5.824 34.0987 5.56 35.6707 5.56C37.8547 5.56 40.1107 6.076 41.7307 6.16C40.9147 8.152 40.1587 10.192 38.8987 12.112C38.6227 12.532 38.3707 12.712 38.2027 12.712C38.0707 12.712 37.9867 12.592 37.9867 12.388C37.9867 12.088 38.2027 11.62 38.3947 11.164C38.4307 11.044 38.3347 10.996 38.2267 10.996H37.7827C37.8307 10.9 37.8667 10.792 37.8667 10.696C37.8667 10.576 37.8187 10.48 37.6987 10.48C37.6507 10.48 37.5907 10.504 37.5067 10.552C37.3267 10.696 37.1707 10.948 37.1707 11.14C37.1707 11.296 37.2907 11.38 37.4467 11.38C37.5907 11.38 37.7347 11.344 37.8787 11.332C37.7587 11.68 37.6387 12.052 37.6387 12.376C37.6387 12.7 37.7707 12.952 38.0707 12.952C38.3107 12.952 38.6107 12.808 38.8027 12.532C39.9067 11.092 40.4827 9.484 41.1667 7.948C40.3867 10.168 39.4747 12.544 38.8867 14.752C38.8267 14.956 38.8027 15.124 38.8027 15.232C38.8027 15.472 38.8987 15.556 38.9947 15.556ZM39.1267 15.232H39.1147H39.1267ZM42.7027 3.544L42.6907 3.532L42.7027 3.544Z"
          fill="currentColor"
        ></path>
        <path
          d="M41.9985 12.544C42.7425 12.544 43.7745 12.064 44.2665 11.332C44.2785 11.308 44.2905 11.284 44.2905 11.26C44.2905 11.2 44.2425 11.176 44.1825 11.176C44.1225 11.176 44.0505 11.212 44.0145 11.284C43.6305 11.956 42.7905 12.328 42.1665 12.328C41.7465 12.328 41.4345 12.16 41.4345 11.8L41.4465 11.644C41.7105 11.584 41.9865 11.488 42.2505 11.368C42.7665 11.104 42.9945 10.804 42.9945 10.588C42.9945 10.444 42.8745 10.348 42.6705 10.348C42.2985 10.348 41.6505 10.696 41.3385 11.248C41.1345 11.272 41.0265 11.428 41.0265 11.56C41.0265 11.632 41.0745 11.692 41.1705 11.704L41.1585 11.872C41.1585 12.34 41.5185 12.544 41.9985 12.544ZM41.6865 11.176C41.9385 10.864 42.4065 10.684 42.5505 10.684C42.5865 10.684 42.5985 10.684 42.5985 10.708C42.5985 10.816 42.1425 11.08 41.6865 11.176Z"
          fill="currentColor"
        ></path>
        <path
          d="M43.9118 12.616C43.9838 12.616 44.0678 12.568 44.0918 12.484C44.2238 12.076 45.0158 10.816 45.5078 10.444C45.3998 10.768 45.0638 11.584 45.0638 11.944C45.0638 12.124 45.1358 12.196 45.2318 12.196C45.5678 12.196 46.2038 11.236 46.5518 11.236C46.6478 11.236 46.7318 11.308 46.7798 11.488C46.8998 11.932 47.1638 12.112 47.4878 12.112C47.8838 12.112 48.3638 11.848 48.7958 11.416C48.8318 11.38 48.8438 11.344 48.8438 11.32C48.8438 11.272 48.8078 11.236 48.7598 11.236C48.7358 11.236 48.6878 11.26 48.6518 11.296C48.2918 11.656 47.8718 11.98 47.5478 11.98C47.3078 11.98 47.1278 11.812 47.0438 11.356C46.9958 11.056 46.8518 10.924 46.6478 10.924C46.3718 10.924 45.9998 11.152 45.6038 11.524C45.7118 11.152 45.8558 10.792 45.8918 10.384C45.8918 10.216 45.8198 10.144 45.7118 10.144C45.5918 10.144 45.4238 10.24 45.2558 10.408C44.9318 10.732 44.4158 11.488 44.1758 11.86C44.3438 11.428 44.5358 11.128 44.5478 11.068L44.5598 10.996C44.5598 10.888 44.4878 10.84 44.3918 10.84C44.2718 10.84 44.1278 10.924 44.0798 11.08V11.092C43.9718 11.428 43.7438 12.1 43.7438 12.4C43.7438 12.556 43.8278 12.616 43.9118 12.616Z"
          fill="currentColor"
        ></path>
        <path
          d="M50.4256 12.22C50.8936 12.22 51.5176 11.968 52.1056 11.368C52.1416 11.332 52.1416 11.308 52.1416 11.284C52.1416 11.248 52.1176 11.224 52.0696 11.224C52.0456 11.224 52.0216 11.224 51.9856 11.272C51.4576 11.824 50.9056 12.088 50.5336 12.088C50.2576 12.088 50.0656 11.944 50.0656 11.632C50.0656 11.476 50.1136 11.284 50.2216 11.044C50.2456 10.996 50.2576 10.96 50.2576 10.924C50.2576 10.852 50.1856 10.804 50.1016 10.804C49.9816 10.804 49.8136 10.888 49.7536 11.044C49.6816 11.26 49.2496 11.8 49.0096 11.8C48.9616 11.8 48.9376 11.764 48.9376 11.704C48.9376 11.428 49.2016 10.996 49.2496 10.792C49.2496 10.696 49.1656 10.648 49.0816 10.648C48.7336 10.648 48.5296 11.356 48.5296 11.704C48.5296 11.932 48.6376 12.076 48.9136 12.076C49.2256 12.076 49.4536 11.848 49.6456 11.632C49.6816 11.992 49.9936 12.22 50.4256 12.22Z"
          fill="currentColor"
        ></path>
        <path
          d="M57.1934 16.408L57.3254 16.384C57.4934 16.324 57.5774 16.192 57.5774 16.072C57.5774 15.988 57.5174 15.916 57.4214 15.916L57.3014 15.94C57.1574 15.94 56.9774 15.544 56.9774 14.992C56.9774 13.948 57.3494 12.352 57.5054 11.728C58.5014 10.624 59.5094 9.364 60.3734 8.116C61.1174 7.036 62.2694 5.164 62.2694 4.204C62.2694 3.832 62.1014 3.604 61.6694 3.604C59.4254 3.604 57.6854 9.604 57.1814 11.824L57.0374 11.98C57.1454 11.68 57.2294 11.32 57.2294 11.008C57.2294 10.624 57.0974 10.36 56.7494 10.36C55.9574 10.36 55.2254 11.728 55.2254 12.52C55.2254 12.856 55.3574 13.084 55.6454 13.084C56.0174 13.084 56.4494 12.82 57.1094 12.16C56.9534 12.88 56.6654 14.344 56.6654 15.34C56.6654 15.628 56.6894 15.88 56.7494 16.06C56.8454 16.312 57.0254 16.408 57.1934 16.408ZM55.8014 12.856C55.6694 12.856 55.6094 12.748 55.6094 12.58C55.6094 11.98 56.3294 10.6 56.7014 10.6C56.8814 10.6 56.9414 10.78 56.9414 11.02C56.9414 11.536 56.6774 12.316 56.6774 12.328C56.2694 12.7 55.9934 12.856 55.8014 12.856ZM57.6014 11.38C58.0214 9.796 60.0494 3.88 61.6454 3.88C61.8974 3.88 62.0054 4.036 62.0054 4.288C62.0054 5.152 60.8054 7.132 60.1934 8.044C59.4374 9.184 58.5494 10.3 57.6014 11.38Z"
          fill="currentColor"
        ></path>
        <path
          d="M59.6343 12.124C60.0543 12.124 60.6303 11.932 61.3623 11.416C61.3983 11.392 61.4103 11.368 61.4103 11.344C61.4103 11.308 61.3863 11.272 61.3383 11.272C61.3143 11.272 61.2903 11.284 61.2543 11.308C60.7983 11.704 60.1983 12.016 59.7903 12.016C59.5143 12.016 59.3343 11.872 59.3343 11.536C59.3343 11.368 59.3703 11.14 59.4783 10.864L59.4903 10.816C59.4903 10.732 59.4063 10.684 59.3223 10.684C59.2143 10.684 59.0823 10.744 59.0103 10.876C58.9143 11.056 58.8543 11.248 58.8543 11.416C58.8543 11.812 59.1183 12.124 59.6343 12.124ZM59.4423 10.324C59.5863 10.324 59.6823 10.24 59.7063 10.12C59.7063 10.06 59.6463 10.012 59.5623 10.012C59.4183 10.012 59.3343 10.096 59.3103 10.216C59.3103 10.276 59.3703 10.324 59.4423 10.324Z"
          fill="currentColor"
        ></path>
        <path
          d="M67.6395 12.94C68.4315 12.928 69.3795 11.944 69.7275 11.368C69.7395 11.344 69.7515 11.308 69.7515 11.284C69.7515 11.224 69.6915 11.188 69.6195 11.188C69.5475 11.188 69.4635 11.224 69.4395 11.296C69.4035 11.38 68.6835 12.808 67.6875 12.808C66.6435 12.808 67.2915 10.864 66.7515 10.864C66.3195 10.864 65.5515 11.836 65.2395 12.232V12.172C65.2395 11.944 65.2875 11.644 65.3475 11.416C68.3955 9.388 70.3755 5.8 70.3755 4.432C70.3755 3.952 70.1715 3.7 69.8235 3.7C69.1395 3.7 67.9275 4.684 66.7755 6.796C65.9235 8.356 65.2635 10.048 64.9515 11.212C64.8555 11.272 64.7955 11.368 64.7955 11.464C64.7955 11.512 64.8075 11.572 64.8555 11.596C64.8075 11.836 64.7595 12.112 64.7475 12.34C64.7475 12.652 64.8555 12.832 65.0355 12.832C65.1915 12.832 65.3835 12.7 65.5995 12.412C66.0555 11.764 66.5235 11.152 66.6795 11.152C66.8835 11.152 66.5595 12.928 67.6395 12.94ZM65.4435 10.996C65.7915 9.676 66.4155 8.08 67.0635 6.856C68.1075 4.876 69.1515 3.964 69.7155 3.964C69.9795 3.964 70.1475 4.156 70.1475 4.54C70.1475 5.128 69.7875 6.124 68.8995 7.492C68.1195 8.692 66.7515 10.336 65.4435 10.996Z"
          fill="currentColor"
        ></path>
        <path
          d="M70.8301 12.268C71.2741 12.268 71.8741 12.004 72.3901 11.452C72.4141 11.428 72.4261 11.392 72.4261 11.368C72.4261 11.332 72.4021 11.308 72.3541 11.308C72.3301 11.308 72.2941 11.32 72.2701 11.356C71.7901 11.872 71.2741 12.148 70.9381 12.148C70.6981 12.148 70.5421 12.004 70.5421 11.728C70.5421 11.5 70.6381 11.176 70.8661 10.756L70.8781 10.708C70.8781 10.624 70.7821 10.588 70.6861 10.588C70.5061 10.588 70.4581 10.648 70.4101 10.756C70.3501 10.708 70.2661 10.684 70.1581 10.684C69.6901 10.732 69.2101 11.488 69.2101 11.932C69.2101 12.1 69.2821 12.22 69.4621 12.22C69.7501 12.22 70.0021 11.98 70.2181 11.704V11.716C70.2181 12.088 70.4701 12.268 70.8301 12.268ZM69.6421 11.848C69.6301 11.848 69.6181 11.836 69.6181 11.812C69.6181 11.644 69.9541 11.032 70.0981 11.032C70.1581 11.032 70.1701 11.092 70.1701 11.164C70.1701 11.224 70.1581 11.284 70.1461 11.308C70.0141 11.56 69.7981 11.848 69.6421 11.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M73.0537 12.976C73.7617 12.976 74.5297 11.992 74.8777 11.368L74.8897 11.32C74.8897 11.284 74.8657 11.26 74.8297 11.26C74.7937 11.26 74.7457 11.284 74.7097 11.332C74.3737 11.932 73.7017 12.856 73.1017 12.856C72.9217 12.856 72.8617 12.736 72.8617 12.556C72.8617 12.1 73.2337 11.392 73.2697 11.296C73.3057 11.2 73.3177 11.152 73.3177 11.104C73.3177 11.032 73.2697 11.008 73.1497 11.008H72.7177C72.7537 10.948 72.8017 10.828 72.8017 10.708C72.8017 10.6 72.7537 10.504 72.6217 10.504C72.3817 10.504 72.1057 10.912 72.1057 11.164C72.1057 11.296 72.1657 11.392 72.3337 11.392C72.4777 11.38 72.4897 11.392 72.8017 11.356C72.6577 11.74 72.5257 12.148 72.5257 12.46C72.5257 12.76 72.6577 12.976 73.0417 12.976H73.0537Z"
          fill="currentColor"
        ></path>
        <path
          d="M75.4195 12.124C75.8395 12.124 76.4155 11.932 77.1475 11.416C77.1835 11.392 77.1955 11.368 77.1955 11.344C77.1955 11.308 77.1715 11.272 77.1235 11.272C77.0995 11.272 77.0755 11.284 77.0395 11.308C76.5835 11.704 75.9835 12.016 75.5755 12.016C75.2995 12.016 75.1195 11.872 75.1195 11.536C75.1195 11.368 75.1555 11.14 75.2635 10.864L75.2755 10.816C75.2755 10.732 75.1915 10.684 75.1075 10.684C74.9995 10.684 74.8675 10.744 74.7955 10.876C74.6995 11.056 74.6395 11.248 74.6395 11.416C74.6395 11.812 74.9035 12.124 75.4195 12.124ZM75.2275 10.324C75.3715 10.324 75.4675 10.24 75.4915 10.12C75.4915 10.06 75.4315 10.012 75.3475 10.012C75.2035 10.012 75.1195 10.096 75.0955 10.216C75.0955 10.276 75.1555 10.324 75.2275 10.324Z"
          fill="currentColor"
        ></path>
        <path
          d="M18.8431 30.576C19.2991 30.576 19.8511 30.192 20.2231 29.568H20.2591C21.2671 29.568 22.3591 28.74 22.4911 28.26C22.4911 28.2 22.4431 28.164 22.3711 28.164C22.2991 28.164 22.2031 28.212 22.1551 28.308C21.9031 28.848 21.1711 29.328 20.5351 29.328L20.3551 29.316C20.5471 28.932 20.6431 28.548 20.6431 28.248C20.6431 27.936 20.5351 27.732 20.2831 27.732C20.2351 27.732 20.1751 27.744 20.1031 27.768C19.7191 27.888 19.4311 28.38 19.4311 28.824C19.4311 29.16 19.5991 29.46 20.0311 29.544C19.7191 30.012 19.3231 30.288 18.9991 30.288C18.6511 30.288 18.3871 29.988 18.3871 29.268C18.3871 29.028 18.4111 28.764 18.4711 28.44C20.0551 27.504 21.5791 25.668 22.5031 24.144C23.2471 22.92 23.5471 22.008 23.5471 21.42C23.5471 20.928 23.3311 20.676 22.9711 20.676C22.3351 20.676 21.2431 21.504 20.1511 23.256C19.2151 24.768 18.3751 26.7 18.0871 28.2C17.9911 28.272 17.9431 28.368 17.9431 28.452C17.9431 28.512 17.9671 28.572 18.0271 28.596C18.0031 28.824 17.9791 29.016 17.9791 29.208C17.9791 30.156 18.3631 30.576 18.8431 30.576ZM18.5791 27.984C18.9031 26.628 19.6351 24.84 20.5231 23.352C21.4831 21.744 22.3711 21.012 22.8511 21.012C23.1031 21.012 23.2471 21.204 23.2471 21.564C23.2471 22.08 22.9591 22.932 22.2871 24.084C21.4711 25.476 20.0551 27.228 18.5791 27.984ZM20.1751 29.28C19.8871 29.184 19.7791 28.932 19.7791 28.68C19.7791 28.296 19.9591 28.008 20.1991 27.972C20.3431 27.972 20.4271 28.14 20.4271 28.38C20.4271 28.62 20.3551 28.932 20.1751 29.28Z"
          fill="currentColor"
        ></path>
        <path
          d="M23.5449 29.268C23.9889 29.268 24.5889 29.004 25.1049 28.452C25.1289 28.428 25.1409 28.392 25.1409 28.368C25.1409 28.332 25.1169 28.308 25.0689 28.308C25.0449 28.308 25.0089 28.32 24.9849 28.356C24.5049 28.872 23.9889 29.148 23.6529 29.148C23.4129 29.148 23.2569 29.004 23.2569 28.728C23.2569 28.5 23.3529 28.176 23.5809 27.756L23.5929 27.708C23.5929 27.624 23.4969 27.588 23.4009 27.588C23.2209 27.588 23.1729 27.648 23.1249 27.756C23.0649 27.708 22.9809 27.684 22.8729 27.684C22.4049 27.732 21.9249 28.488 21.9249 28.932C21.9249 29.1 21.9969 29.22 22.1769 29.22C22.4649 29.22 22.7169 28.98 22.9329 28.704V28.716C22.9329 29.088 23.1849 29.268 23.5449 29.268ZM22.3569 28.848C22.3449 28.848 22.3329 28.836 22.3329 28.812C22.3329 28.644 22.6689 28.032 22.8129 28.032C22.8729 28.032 22.8849 28.092 22.8849 28.164C22.8849 28.224 22.8729 28.284 22.8609 28.308C22.7289 28.56 22.5129 28.848 22.3569 28.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M27.7606 29.94C28.5526 29.928 29.5006 28.944 29.8486 28.368C29.8606 28.344 29.8726 28.308 29.8726 28.284C29.8726 28.224 29.8126 28.188 29.7406 28.188C29.6686 28.188 29.5846 28.224 29.5606 28.296C29.5246 28.38 28.8046 29.808 27.8086 29.808C26.7646 29.808 27.4126 27.864 26.8726 27.864C26.4406 27.864 25.6726 28.836 25.3606 29.232V29.172C25.3606 28.944 25.4086 28.644 25.4686 28.416C28.5166 26.388 30.4966 22.8 30.4966 21.432C30.4966 20.952 30.2926 20.7 29.9446 20.7C29.2606 20.7 28.0486 21.684 26.8966 23.796C26.0446 25.356 25.3846 27.048 25.0726 28.212C24.9766 28.272 24.9166 28.368 24.9166 28.464C24.9166 28.512 24.9286 28.572 24.9766 28.596C24.9286 28.836 24.8806 29.112 24.8686 29.34C24.8686 29.652 24.9766 29.832 25.1566 29.832C25.3126 29.832 25.5046 29.7 25.7206 29.412C26.1766 28.764 26.6446 28.152 26.8006 28.152C27.0046 28.152 26.6806 29.928 27.7606 29.94ZM25.5646 27.996C25.9126 26.676 26.5366 25.08 27.1846 23.856C28.2286 21.876 29.2726 20.964 29.8366 20.964C30.1006 20.964 30.2686 21.156 30.2686 21.54C30.2686 22.128 29.9086 23.124 29.0206 24.492C28.2406 25.692 26.8726 27.336 25.5646 27.996Z"
          fill="currentColor"
        ></path>
        <path
          d="M30.9512 29.268C31.3952 29.268 31.9952 29.004 32.5112 28.452C32.5352 28.428 32.5472 28.392 32.5472 28.368C32.5472 28.332 32.5232 28.308 32.4752 28.308C32.4512 28.308 32.4152 28.32 32.3912 28.356C31.9112 28.872 31.3952 29.148 31.0592 29.148C30.8192 29.148 30.6632 29.004 30.6632 28.728C30.6632 28.5 30.7592 28.176 30.9872 27.756L30.9992 27.708C30.9992 27.624 30.9031 27.588 30.8071 27.588C30.6271 27.588 30.5792 27.648 30.5312 27.756C30.4712 27.708 30.3872 27.684 30.2792 27.684C29.8112 27.732 29.3312 28.488 29.3312 28.932C29.3312 29.1 29.4032 29.22 29.5832 29.22C29.8712 29.22 30.1232 28.98 30.3392 28.704V28.716C30.3392 29.088 30.5912 29.268 30.9512 29.268ZM29.7632 28.848C29.7512 28.848 29.7392 28.836 29.7392 28.812C29.7392 28.644 30.0752 28.032 30.2192 28.032C30.2792 28.032 30.2912 28.092 30.2912 28.164C30.2912 28.224 30.2792 28.284 30.2672 28.308C30.1352 28.56 29.9192 28.848 29.7632 28.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M27.3788 38.04C30.4628 38.028 33.2828 33.12 34.1468 29.76C34.8668 29.436 35.7428 28.98 36.1868 28.296C36.2108 28.26 36.2228 28.224 36.2228 28.2C36.2228 28.128 36.1748 28.092 36.1028 28.092C36.0428 28.092 35.9588 28.128 35.9108 28.212C35.5388 28.788 34.8428 29.172 34.2188 29.472C34.3388 28.98 34.5068 27.924 34.5068 27.384C34.5068 27.12 34.4588 27 34.3388 27C34.1828 27 33.9548 27.348 33.7988 27.636C33.6908 27.42 33.5468 27.336 33.3548 27.336C32.7908 27.336 32.1308 28.56 32.1308 29.256C32.1308 29.532 32.2388 29.724 32.4908 29.724C32.9468 29.724 33.4268 28.788 33.6788 28.332C33.8228 28.296 33.9428 28.152 33.9428 28.044L33.9068 27.912L34.1828 27.456C34.1108 28.164 33.9308 28.98 33.7148 29.712C27.7988 32.4 25.9148 35.04 25.9148 36.6C25.9148 37.5 26.5268 38.04 27.3668 38.04H27.3788ZM32.5628 29.496C32.4668 29.496 32.4308 29.424 32.4308 29.292C32.4308 28.812 33.0068 27.648 33.2948 27.648C33.4988 27.648 33.4268 28.2 33.4748 28.272C33.3428 28.512 32.8508 29.496 32.5628 29.496ZM27.4748 37.86H27.4388C26.6468 37.86 26.0948 37.356 26.0948 36.528C26.0948 35.016 27.9548 32.436 33.6428 29.988C32.7428 33.036 30.4388 37.812 27.4748 37.86Z"
          fill="currentColor"
        ></path>
        <path
          d="M36.6304 29.124C37.0504 29.124 37.6264 28.932 38.3584 28.416C38.3944 28.392 38.4064 28.368 38.4064 28.344C38.4064 28.308 38.3824 28.272 38.3344 28.272C38.3104 28.272 38.2864 28.284 38.2504 28.308C37.7944 28.704 37.1944 29.016 36.7864 29.016C36.5104 29.016 36.3304 28.872 36.3304 28.536C36.3304 28.368 36.3664 28.14 36.4744 27.864L36.4864 27.816C36.4864 27.732 36.4024 27.684 36.3184 27.684C36.2104 27.684 36.0784 27.744 36.0064 27.876C35.9104 28.056 35.8504 28.248 35.8504 28.416C35.8504 28.812 36.1144 29.124 36.6304 29.124ZM36.4384 27.324C36.5824 27.324 36.6784 27.24 36.7024 27.12C36.7024 27.06 36.6424 27.012 36.5584 27.012C36.4144 27.012 36.3304 27.096 36.3064 27.216C36.3064 27.276 36.3664 27.324 36.4384 27.324Z"
          fill="currentColor"
        ></path>
        <path
          d="M39.6113 29.268C40.0553 29.268 40.6553 29.004 41.1713 28.452C41.1953 28.428 41.2073 28.392 41.2073 28.368C41.2073 28.332 41.1833 28.308 41.1353 28.308C41.1113 28.308 41.0753 28.32 41.0513 28.356C40.5713 28.872 40.0553 29.148 39.7193 29.148C39.4793 29.148 39.3233 29.004 39.3233 28.728C39.3233 28.5 39.4193 28.176 39.6473 27.756L39.6593 27.708C39.6593 27.624 39.5633 27.588 39.4673 27.588C39.2873 27.588 39.2393 27.648 39.1913 27.756C39.1313 27.708 39.0473 27.684 38.9393 27.684C38.4713 27.732 37.9913 28.488 37.9913 28.932C37.9913 29.1 38.0633 29.22 38.2433 29.22C38.5313 29.22 38.7833 28.98 38.9993 28.704V28.716C38.9993 29.088 39.2513 29.268 39.6113 29.268ZM38.4233 28.848C38.4113 28.848 38.3993 28.836 38.3993 28.812C38.3993 28.644 38.7353 28.032 38.8793 28.032C38.9393 28.032 38.9513 28.092 38.9513 28.164C38.9513 28.224 38.9393 28.284 38.9273 28.308C38.7953 28.56 38.5793 28.848 38.4233 28.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M44.5672 30.648C44.7112 30.648 44.9032 30.516 45.1552 30.228C45.3592 29.976 45.6472 29.592 45.8152 29.352C45.9712 29.748 46.3672 29.94 46.8472 29.94C47.6992 29.94 48.8392 29.364 49.4992 28.38C49.5232 28.344 49.5352 28.308 49.5352 28.284C49.5352 28.224 49.4752 28.188 49.4152 28.188C49.3432 28.188 49.2712 28.212 49.2232 28.296C48.5512 29.304 47.6032 29.76 46.9072 29.76C46.4272 29.76 46.0672 29.532 46.0192 29.112C46.9192 29.004 47.8072 27.804 47.8072 27.348C47.8072 27.204 47.7352 27.144 47.6152 27.144C47.4952 27.144 47.3392 27.204 47.1712 27.312C46.3672 27.84 45.2632 29.496 44.7832 30.06V30.024C44.7832 29.616 44.9632 28.896 45.0952 28.476C48.0472 26.448 50.1952 22.896 50.1952 21.408C50.1952 20.94 50.0032 20.688 49.6672 20.688C48.9832 20.688 47.7112 21.768 46.4272 24.216C45.7312 25.536 45.1192 27.024 44.7232 28.26C44.6632 28.32 44.6272 28.392 44.6272 28.464L44.6392 28.536C44.4952 29.016 44.3032 29.76 44.3032 30.228C44.3032 30.48 44.3992 30.648 44.5672 30.648ZM45.2272 28.008C45.5872 26.82 46.1392 25.428 46.7152 24.264C47.8672 21.972 48.9952 20.94 49.5712 20.94C49.8232 20.94 49.9672 21.132 49.9672 21.504C49.9672 21.96 49.7392 22.704 49.1992 23.664C48.3712 25.128 46.7272 27.24 45.2272 28.008ZM46.2112 28.836C46.4512 28.512 47.0632 27.696 47.4232 27.528C47.3152 27.936 46.7632 28.668 46.2112 28.836Z"
          fill="currentColor"
        ></path>
        <path
          d="M50.6387 29.268C51.0827 29.268 51.6827 29.004 52.1987 28.452C52.2227 28.428 52.2347 28.392 52.2347 28.368C52.2347 28.332 52.2107 28.308 52.1627 28.308C52.1387 28.308 52.1027 28.32 52.0787 28.356C51.5987 28.872 51.0827 29.148 50.7467 29.148C50.5067 29.148 50.3507 29.004 50.3507 28.728C50.3507 28.5 50.4467 28.176 50.6747 27.756L50.6867 27.708C50.6867 27.624 50.5907 27.588 50.4947 27.588C50.3147 27.588 50.2667 27.648 50.2187 27.756C50.1587 27.708 50.0747 27.684 49.9667 27.684C49.4987 27.732 49.0187 28.488 49.0187 28.932C49.0187 29.1 49.0907 29.22 49.2707 29.22C49.5587 29.22 49.8107 28.98 50.0267 28.704V28.716C50.0267 29.088 50.2787 29.268 50.6387 29.268ZM49.4507 28.848C49.4387 28.848 49.4267 28.836 49.4267 28.812C49.4267 28.644 49.7627 28.032 49.9067 28.032C49.9667 28.032 49.9787 28.092 49.9787 28.164C49.9787 28.224 49.9667 28.284 49.9547 28.308C49.8227 28.56 49.6067 28.848 49.4507 28.848Z"
          fill="currentColor"
        ></path>
        <path
          d="M51.9743 29.616C52.0463 29.616 52.1303 29.568 52.1543 29.484C52.2863 29.076 53.0783 27.816 53.5703 27.444C53.4623 27.768 53.1263 28.584 53.1263 28.944C53.1263 29.124 53.1983 29.196 53.2943 29.196C53.6303 29.196 54.2663 28.236 54.6143 28.236C54.7103 28.236 54.7943 28.308 54.8423 28.488C54.9623 28.932 55.2263 29.112 55.5503 29.112C55.9463 29.112 56.4263 28.848 56.8583 28.416C56.8943 28.38 56.9063 28.344 56.9063 28.32C56.9063 28.272 56.8703 28.236 56.8223 28.236C56.7983 28.236 56.7503 28.26 56.7143 28.296C56.3543 28.656 55.9343 28.98 55.6103 28.98C55.3703 28.98 55.1903 28.812 55.1063 28.356C55.0583 28.056 54.9143 27.924 54.7103 27.924C54.4343 27.924 54.0623 28.152 53.6663 28.524C53.7743 28.152 53.9183 27.792 53.9543 27.384C53.9543 27.216 53.8823 27.144 53.7743 27.144C53.6543 27.144 53.4863 27.24 53.3183 27.408C52.9943 27.732 52.4783 28.488 52.2383 28.86C52.4063 28.428 52.5983 28.128 52.6103 28.068L52.6223 27.996C52.6223 27.888 52.5503 27.84 52.4543 27.84C52.3343 27.84 52.1903 27.924 52.1423 28.08V28.092C52.0343 28.428 51.8063 29.1 51.8063 29.4C51.8063 29.556 51.8903 29.616 51.9743 29.616Z"
          fill="currentColor"
        ></path>
        <path
          d="M57.3961 29.124C57.8161 29.124 58.3921 28.932 59.1241 28.416C59.1601 28.392 59.1721 28.368 59.1721 28.344C59.1721 28.308 59.1481 28.272 59.1001 28.272C59.0761 28.272 59.0521 28.284 59.0161 28.308C58.5601 28.704 57.9601 29.016 57.5521 29.016C57.2761 29.016 57.0961 28.872 57.0961 28.536C57.0961 28.368 57.1321 28.14 57.2401 27.864L57.2521 27.816C57.2521 27.732 57.1681 27.684 57.0841 27.684C56.9761 27.684 56.8441 27.744 56.7721 27.876C56.6761 28.056 56.6161 28.248 56.6161 28.416C56.6161 28.812 56.8801 29.124 57.3961 29.124ZM57.2041 27.324C57.3481 27.324 57.4441 27.24 57.4681 27.12C57.4681 27.06 57.4081 27.012 57.3241 27.012C57.1801 27.012 57.0961 27.096 57.0721 27.216C57.0721 27.276 57.1321 27.324 57.2041 27.324Z"
          fill="currentColor"
        ></path>
      </svg>

      <div class="mb-5 name font-secondary text-gold mt-4" style="font-size: 26px">
        {{ wedding.man.surname }} 
        &
        {{ wedding.woman.surname }}
      </div>
    </div>

    <section class="bg-white footer pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format("YYYY") }}. Made by
        <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
      <div class="flex mt-2 mb-2 w-full justify-center">
        <a href="https://fb.com/ceremonyku" target="_blank" class="mx-2"
          ><svg
            id="facebook"
            xmlns="http://www.w3.org/2000/svg"
            width="26.694"
            height="26.694"
            viewBox="0 0 26.694 26.694"
          >
            <path
              id="Path_444"
              data-name="Path 444"
              d="M5.966,3H26.728a2.966,2.966,0,0,1,2.966,2.966V26.728a2.966,2.966,0,0,1-2.966,2.966H5.966A2.966,2.966,0,0,1,3,26.728V5.966A2.966,2.966,0,0,1,5.966,3M25.245,5.966H21.537a5.19,5.19,0,0,0-5.19,5.19v3.707H13.381v4.449h2.966V29.694H20.8V19.313h4.449V14.864H20.8V11.9a1.483,1.483,0,0,1,1.483-1.483h2.966Z"
              transform="translate(-3 -3)"
              fill="#283a60"
            ></path></svg
        ></a>
        <a
          href="https://www.instagram.com/ceremonyku/"
          target="_blank"
          class="mx-2"
          ><svg
            id="instagram"
            xmlns="http://www.w3.org/2000/svg"
            width="26.694"
            height="26.694"
            viewBox="0 0 26.694 26.694"
          >
            <path
              id="Path_443"
              data-name="Path 443"
              d="M9.741,2H20.953a7.747,7.747,0,0,1,7.741,7.741V20.953a7.741,7.741,0,0,1-7.741,7.741H9.741A7.747,7.747,0,0,1,2,20.953V9.741A7.741,7.741,0,0,1,9.741,2M9.474,4.669a4.8,4.8,0,0,0-4.8,4.8V21.22a4.8,4.8,0,0,0,4.8,4.8H21.22a4.8,4.8,0,0,0,4.8-4.8V9.474a4.8,4.8,0,0,0-4.8-4.8H9.474m12.88,2A1.668,1.668,0,1,1,20.686,8.34a1.668,1.668,0,0,1,1.668-1.668m-7.007,2a6.673,6.673,0,1,1-6.673,6.673,6.673,6.673,0,0,1,6.673-6.673m0,2.669a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
              transform="translate(-2 -2)"
              fill="#283a60"
            ></path></svg
        ></a>
        <a href="https://wa.me/6285739137858" target="_blank" class="mx-2"
          ><svg
            id="whatsapp"
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
          >
            <path
              id="Path_445"
              data-name="Path 445"
              d="M21.175,17.548c.325.169.533.26.6.39a2.559,2.559,0,0,1-.273,1.534,3.166,3.166,0,0,1-2.21,1.456c-.6.026-.611.468-3.848-.949s-5.187-4.875-5.343-5.1A6.3,6.3,0,0,1,8.9,11.49a3.543,3.543,0,0,1,1.235-2.652.969.969,0,0,1,.884-.338h.611c.2,0,.468-.078.715.585l.9,2.431a.593.593,0,0,1,.013.572l-.351.533-.507.546c-.156.156-.338.325-.156.65a9.648,9.648,0,0,0,1.716,2.314,8.59,8.59,0,0,0,2.535,1.69c.312.182.507.156.7-.052l1.053-1.222c.247-.325.455-.247.754-.143l2.171,1.144M15,2A13,13,0,1,1,8.045,25.985L2,28l2.015-6.045A13,13,0,0,1,15,2m0,2.6A10.4,10.4,0,0,0,6.5,20.993L5.25,24.75,9.007,23.5A10.4,10.4,0,1,0,15,4.6Z"
              transform="translate(-2 -2)"
              fill="#283a60"
            ></path></svg
        ></a>
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height" />
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 =
  "https://ik.imagekit.io/aryraditya/agusyogi-toniari/30_2.jpg?updatedAt=1634058283256&tr=w-800";
const ImageHero2 =
  "https://ik.imagekit.io/aryraditya/agusyogi-toniari/OKI09434.jpg?updatedAt=1634058288907&tr=w-800";
// const ImageHero3 =
// "https://ik.imagekit.io/aryraditya/ceremonyku/jerocik-sariani/MX3_0118.jpg?updatedAt=1634044805137&tr=w-800";

import Audio from "@/assets/audio/soundtrack.mp3";

import AGWHero from "@/components/Hero/HeroTwo";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery/GalleryOne";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";
import Himbauan from "./components/Himbauan.vue";

import { setInterval } from "timers";

const SESSION = [
  ["2021-10-27 13:00", "Selesai"],
  // ["2021-09-09 16:30", "Selesai"]
];

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWAudio,
    GuestBox,
    Attendance,
    Himbauan,
  },
  data() {
    return {
      title: "Pawiwahan",
      backgrounds: [ImageHero1, ImageHero2],
      giftOpen: false,
      bgActive: 0,
      dividerHeight: 0,
      overflow: true,
      coverImage: "",
      location:
        "Jl. Bukit Hijau VIII Lingk. Mekar Sari, Jimbaran, Kab. Badung - Bali",
      direction: "https://goo.gl/maps/gTxsW7Go3GS2",
      time: {
        start: this.$moment("2021-10-27 13:00"),
        end: "Selesai",
      },
      wedding: {
        man: {
          name: "Gede Agus Purnama Yogi",
          surname: "Agus Yogi",
          parents: "I Gede Putu Arta, S.H & Ni Nyoman Sutarmi",
          description: "Putra kelima",
          address:
            "Jl. Bukit Hijau VIII Lingk. Mekar Sari, Jimbaran, Kab. Badung - Bali",
          photo:
            "https://ik.imagekit.io/aryraditya/agusyogi-toniari/29.jpg?updatedAt=1634058282369&tr=w-554,h-693,fo-custom,cm-extract",
        },
        woman: {
          name: "Ni Putu Juni Toniari",
          surname: "Toniari",
          parents: "I Wayan Rutawan, S.E., M.A.P. & Ni Wayan Suartini, A.Md.Keb",
          address: " Br. Kebalian, Sukawati, Kab. Gianyar - Bali",
          description: "Putri pertama",
          photo:
            "https://ik.imagekit.io/aryraditya/agusyogi-toniari/21.jpg?updatedAt=1634058280406&tr=w-517,h-647,fo-custom,cm-extract",
        },
      },
      mepandes: [],
      gallery: [],
      music: {
        file: Audio,
        autoplay: true,
        loop: true,
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false,
      },
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    },
    session() {
      const url = new URLSearchParams(window.location.search);
      const sesi = Number(url.get("sesi")) || 1;
      return sesi > SESSION.length ? 1 : sesi;
    },
  },
  mounted() {
    const [start, end] = SESSION[this.session - 1] || SESSION[0];

    this.time.start = this.$moment(start);
    this.time.end = end;

    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.sw.refreshing) return;
        this.sw.refreshing = true;
        window.location.reload();
      });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    },
    openWebsite() {
      this.overflow = false;
      document.querySelector("#loading").classList.remove("active");
      if (this.$refs.audio) this.$refs.audio.play();
    },
    copyToClipboard(text, e) {
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.style.height = '1px'
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      console.log({ e })
      const copiedText = document.createElement('div')
      e.target.after(copiedText)
      copiedText.innerHTML = 'Copied!'
      copiedText.style.fontSize = '80%'

      setTimeout(() => copiedText.remove(), 2000)
    }
  },
};
</script>

<style lang="scss" scoped>
.overflow-fade-enter-active {
  transition: all 1s ease;
}
.overflow-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.overflow-fade-enter,
.overflow-fade-leave-to {
  opacity: 0;
}

.wedding-gift {
  width: 100%;
  padding: 0.5rem 1rem;
  animation: tada 3s infinite;
  animation-delay: 2s;
  // background: #f74f85;
  // box-shadow: 0 14px 26px -12px rgb(250 75 139 / 42%),
  //   0 4px 23px 0 rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(250 75 139 / 20%);
  border: 0;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 4px;

  svg {
    width: 40px;
  }
}
@keyframes headShake {
  0% {
    transform: translateX(0);
  }

  1% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  5% {
    transform: translateX(5px) rotateY(7deg);
  }

  9% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  13% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }

  5%,
  10% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  15%,
  25%,
  35%,
  45% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 3deg);
  }

  20%,
  30%,
  40% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -3deg);
  }

  50% {
    transform: scale3d(1, 1, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}


.wedding-gift-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 4rem 0;
  text-align: center;
  overflow-y: auto;
  max-height: 100vh;

  button.close {
    font-size: 4rem;
    position: absolute;
    top: 1rem;
    right: 1rem;
    line-height: 0;
    padding: .5rem;
  }

  h2 {
    text-align: center;
    font-size: 1.75rem;
    text-transform: uppercase;
    margin-bottom: 1rem;

    + div {
      line-height: 1.2;
    }
  }

  img {
    height: 30px;
  }

  .copy {
    border: 0;
    background: #333;
    color: #fff;
    padding: 8px 24px 9px;
    border-radius: 5rem;
    line-height: 1;
    font-size: 80%;
    margin-top: .5rem;

    svg {
      width: 15px;
      height: 15px;
      margin-right: .5rem;
      path {
        fill: currentColor;
      }
    }
  }
}
</style>
